import { Component, Input, AfterViewInit, OnInit, HostBinding } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import 'rxjs/Rx';
import { NgForm, FormControl, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { MdInputModule } from '@angular/material';

import { AppConstants } from '../../../shared/constants/constants';
import { Utility } from '../../../common/utility';
import { ValidationService } from '../../../shared/services/validation.service';

@Component({
  selector: 'form-message',
  templateUrl: 'message.component.html'
})
export class FormMessageComponent implements OnInit {
  @HostBinding('class.form-error') formMessageClass = true;
  @Input() control: FormControl;
  @Input() subControl?: FormControl;
  @Input() form: any; // FormControl;
  @Input() label: string;

  constructor() {
  }

  public errorMessage(control: AbstractControl) {
    // console.log("errorMessage");
    for (const propertyName in control.errors) {
      if (control.errors.hasOwnProperty(propertyName)) {
        // if (propertyName === 'max' || propertyName === 'min') {
        //   return ValidationService.getValidatorErrorMessage(propertyName + '/' + control.errors[propertyName][propertyName], this.label);
        // }
        return ValidationService.getValidatorErrorMessage(propertyName, this.label);
      }
    }
    return null;
  }


  ngOnInit() {
    // console.log(this.model);
  }

}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/components/form/message/message.component.ts